import * as React from "react";
import classnames from "classnames";
import { Button } from "@grandvisionhq/common";
/* empty css                  */
const SocialButton = ({ onClick, socialProvider, caption, className, ...rest }) => /* @__PURE__ */ React.createElement(
  Button,
  {
    ...rest,
    icon: `social-${socialProvider}`,
    size: "custom",
    variant: "barebones",
    onClick,
    className: classnames("social-button", `social-button--${socialProvider}`, className),
    caption
  }
);
export {
  SocialButton
};
//# sourceMappingURL=SocialButton.js.map
